import React from "react";
import { useTranslation } from "react-i18next";
import { Coupoun } from "../../../types/modules/admin/coupoun.type";
import CoupounItem from "./CoupounItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  copouns: Coupoun[];
}

const CoupounsListTable: React.FC<Props> = ({ copouns }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("code")}</th>
            <th className="p-3 font-normal capitalize">{t("discountPercentage")}</th>
            <th className="p-3 font-normal capitalize">{t("maxUsage")}</th>
            <th className="p-3 font-normal capitalize">{t("usedCount")}</th>
            <th className="p-3 font-normal capitalize">{t("startDate")}</th>
            <th className="p-3 font-normal capitalize">{t("endDate")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateCoupon]}>
              <>
              <th className="p-3 font-normal capitalize">{t("active")}</th>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
              </>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {copouns.map((copoun, index) => (
            <tr
              key={copoun.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <CoupounItem coupoun={copoun}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CoupounsListTable;